import React from "react";
import { useNavigate } from "react-router-dom";
import { contextapi } from "../../helpers/contextapi";
import { axiospost } from "../../helpers/httprequest";
import is_null from "../../helpers/is_null";
import swal from "../../helpers/swal";
import { Form, Formik } from "formik";
import ErrorMessage from "../../components/ErrorMessage";
import { ms_applicant } from "@v2/validators";
import GoogleSignIn from "./GoogleSignIn";

const Login = () => {
  const context = React.useContext(contextapi);
  const navigate = useNavigate();
  const [singleLogin, setSingleLogin] = React.useState(null);

  React.useEffect(() => {
    localStorage.clear();
    context.setvalues([]);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    if (singleLogin !== null) {
      // console.log(singleLogin)
      localStorage.setItem("isStudentAuth", singleLogin.token);
      localStorage.setItem("isStudent", JSON.stringify(singleLogin.user));
      context.setvalues({ ...context.values, user: singleLogin.user });
      swal("success", "Your login was successful");

      if (!singleLogin?.user?.ispasswordchanged) {
        navigate("/app/change");
        return;
      }

      if (singleLogin?.user?.status === 1) {
        navigate("/app/dashboard");
        return;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleLogin]);
  const _login = async (values) => {
    try {
      const uname = values.emailaddress;
      const upass = values.password;
      if (is_null(uname) || is_null(upass)) {
        swal("warning", "Please fill the form properly");
        return;
      }
      const req = await axiospost("ms_students/login", {
        emailaddress: uname,
        password: upass,
      });
      if (req.status !== 200 || !is_null(req?.type)) {
        if (is_null(req?.type)) throw new Error("Sorry, system could not finish processing your request");
        else throw new Error(req?.message);
      }
      const { data } = req;
      if (data.token) {
        localStorage.setItem("isStudentAuth", data.token);
        localStorage.setItem("isStudent", JSON.stringify(data.user));
        context.setvalues({ ...context.values, user: data.user });
        swal("success", "Your login was successful");

        if (!data?.user?.ispasswordchanged) {
          navigate("/app/change");
          return;
        }

        if (data?.user?.status === 1) {
          navigate("/app/dashboard");
          return;
        }
      } else {
        throw new Error(data.message);
      }
    } catch ({ message }) {
      swal("error", message);
    }
  };
  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-8 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                <div className="brand-logo text-center">
                  <img src="images/logo.png" alt="logo" />
                </div>
                <div className="text-center">
                  <h4 className="text-uppercase font-weight-bold mb-3">Kebbi State Polytechnic Dakingari</h4>
                  <h6 className="font-weight-light text-uppercase"> Student Portal</h6>
                  <h6 className="font-weight-light">Sign in to continue</h6>
                </div>
                <Formik
                  initialValues={{ emailaddress: "", password: "" }}
                  validationSchema={ms_applicant.applicantloginrule}
                  initialTouched={{ zip: true }}
                  onSubmit={_login}
                >
                  {({ isSubmitting, touched, errors }) => (
                    <Form className="my-4">
                      <ErrorMessage
                        name={"emailaddress"}
                        label="Email Address"
                        type="email"
                        errors={errors?.emailaddress}
                        touched={touched?.emailaddress}
                      />

                      <ErrorMessage name={"password"} label="Password" type="password" errors={errors?.password} touched={touched?.password} />
                      <div className="mt-3">
                        <button disabled={isSubmitting} type="submit" className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">
                          {isSubmitting ? "Please wait..." : "Login to Account"}
                        </button>
                      </div>
                      <div className="row my-4">
                        <div className="col-md-8"></div>
                        <div className="col-md-4">
                          <GoogleSignIn setLogin={setSingleLogin} />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
